import * as i0 from '@angular/core';
import { InjectionToken, Directive, Optional, Inject, Input, HostBinding, NgModule } from '@angular/core';
import { updateSvg, updateCanvas } from 'jdenticon/browser';

const JDENTICON_CONFIG = new InjectionToken('JdenticonConfig');

// Use same attributes as for VanillaJS Jdenticon.
// tslint:disable:directive-selector no-input-rename
class SvgJdenticonDirective {
    constructor(el, zone, config) {
        this.el = el;
        this.zone = zone;
        this.config = config;
    }
    ngOnChanges() {
        // setTimeout is used to ensure that Angular has updated the host attributes.
        // runOutsideAngular is used to prevent an additional Angular change detection.
        this.zone.runOutsideAngular(() => {
            setTimeout(() => {
                updateSvg(this.el.nativeElement, undefined, this.config);
            });
        });
    }
}
SvgJdenticonDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SvgJdenticonDirective, deps: [{ token: i0.ElementRef }, { token: i0.NgZone }, { token: JDENTICON_CONFIG, optional: true }], target: i0.ɵɵFactoryTarget.Directive });
SvgJdenticonDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.12", type: SvgJdenticonDirective, selector: "svg[data-jdenticon-hash],svg[data-jdenticon-value]", inputs: { hash: ["data-jdenticon-hash", "hash"], value: ["data-jdenticon-value", "value"], width: "width", height: "height" }, host: { properties: { "attr.data-jdenticon-hash": "this.hash", "attr.data-jdenticon-value": "this.value", "attr.width": "this.width", "attr.height": "this.height" } }, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: SvgJdenticonDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'svg[data-jdenticon-hash],svg[data-jdenticon-value]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.NgZone }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [JDENTICON_CONFIG]
                }] }]; }, propDecorators: { hash: [{
                type: Input,
                args: ['data-jdenticon-hash']
            }, {
                type: HostBinding,
                args: ['attr.data-jdenticon-hash']
            }], value: [{
                type: Input,
                args: ['data-jdenticon-value']
            }, {
                type: HostBinding,
                args: ['attr.data-jdenticon-value']
            }], width: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['attr.width']
            }], height: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['attr.height']
            }] } });

// Use same attributes as for VanillaJS Jdenticon.
// tslint:disable:directive-selector no-input-rename
class CanvasJdenticonDirective {
    constructor(el, zone, config) {
        this.el = el;
        this.zone = zone;
        this.config = config;
    }
    ngOnChanges() {
        // setTimeout is used to ensure that Angular has updated the host attributes.
        // runOutsideAngular is used to prevent an additional Angular change detection.
        this.zone.runOutsideAngular(() => {
            setTimeout(() => {
                updateCanvas(this.el.nativeElement, undefined, this.config);
            });
        });
    }
}
CanvasJdenticonDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: CanvasJdenticonDirective, deps: [{ token: i0.ElementRef }, { token: i0.NgZone }, { token: JDENTICON_CONFIG, optional: true }], target: i0.ɵɵFactoryTarget.Directive });
CanvasJdenticonDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.12", type: CanvasJdenticonDirective, selector: "canvas[data-jdenticon-hash],canvas[data-jdenticon-value]", inputs: { hash: ["data-jdenticon-hash", "hash"], value: ["data-jdenticon-value", "value"], width: "width", height: "height" }, host: { properties: { "attr.data-jdenticon-hash": "this.hash", "attr.data-jdenticon-value": "this.value", "attr.width": "this.width", "attr.height": "this.height" } }, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: CanvasJdenticonDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'canvas[data-jdenticon-hash],canvas[data-jdenticon-value]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.NgZone }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [JDENTICON_CONFIG]
                }] }]; }, propDecorators: { hash: [{
                type: Input,
                args: ['data-jdenticon-hash']
            }, {
                type: HostBinding,
                args: ['attr.data-jdenticon-hash']
            }], value: [{
                type: Input,
                args: ['data-jdenticon-value']
            }, {
                type: HostBinding,
                args: ['attr.data-jdenticon-value']
            }], width: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['attr.width']
            }], height: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['attr.height']
            }] } });

class NgxJdenticonModule {
}
NgxJdenticonModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: NgxJdenticonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
NgxJdenticonModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: NgxJdenticonModule, declarations: [SvgJdenticonDirective, CanvasJdenticonDirective], exports: [SvgJdenticonDirective, CanvasJdenticonDirective] });
NgxJdenticonModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: NgxJdenticonModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: NgxJdenticonModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SvgJdenticonDirective, CanvasJdenticonDirective],
                    exports: [SvgJdenticonDirective, CanvasJdenticonDirective]
                }]
        }] });

/*
 * Public API Surface of ngx-jdenticon
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CanvasJdenticonDirective, JDENTICON_CONFIG, NgxJdenticonModule, SvgJdenticonDirective };
